import * as React from "react";
import Button from "antd/lib/button";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Tooltip from "antd/lib/tooltip";

import { useSelector, useDispatch } from "react-redux";
import { useCtx } from 'one-ui-provider';
import { Disposition } from 'one-model-local';


const restRequest = (actions: any, options: any,log:any) => {
  if (actions) {
    actions.updatecv(options)
      .catch((e: any) => {
        log.error(
          "one-micro-quickmenu",
          "hotbuttons-restRequest",{
            e
          }
        );
      });
  }
}

const updatePV=(actions: any,usepv:any,log:any) =>{
  //get the selected type
  let selected=sessionStorage.getItem("selected")
      let callvar = {
        "name" : usepv,
        "value" : selected

    };
    let callvariable = { "CallVariable" : callvar };
    let mediaProperties = { "callvariables": callvariable };
    let options:any = options || {};
    options.content = {};
    options.content["Dialog"] =
    {
      "mediaProperties": mediaProperties,
      "requestedAction": "UPDATE_CALL_DATA"
    };
    options.method = "PUT";
    options.success = function() {
      log.debug(
        "one-card-hotbutons",
        "hotbuttons-Call Vars updated successfully"
      );
    };
    options.error = function() {
      log.error(
        "one-card-hotbutons",
        "hotbuttons-Failed to update call variable"
      );
    };
    // Update the variables
    restRequest(actions,options,log);
}

const transfer = (actions: any, target: any, usepv:any, updatepvornot:boolean,log:any, type: any, label: any, contact_center_type: any, agentId: any, callId: any, dispatch: any) => {
  if(updatepvornot){
    updatePV(actions,usepv,log);
  }
  if (actions) {
    actions.transfer(target)
      .then((e: any) => {
        //Disposition Framework
        let disp: Disposition = { value: "175" }
        if (contact_center_type && contact_center_type === 'five9') {
          let agentIdValue = sessionStorage.getItem("agentName");
          disp.meta00 = agentIdValue;
        } else {
          disp.meta00 = agentId;
          disp.dial_list_uid = callId;
        }
        disp.meta01 = label;
        disp.meta02 = target;
        disp.meta03 = type;
        disp.meta04 = 'client';
        dispatch({
          type: "store-disposition-code",
          payload: disp
        })
      })
      .catch((excep: any) => {
        log.error(
          "one-card-hotbutons",
          "hotbuttons-transfer", {
          excep
        }
        );
        //Disposition Framework
        let disp: Disposition = { value: "990" }
        if (contact_center_type && contact_center_type === 'five9') {
          let agentIdValue = sessionStorage.getItem("agentName");
          disp.meta00 = agentIdValue;
        } else {
          disp.meta00 = agentId;
          disp.dial_list_uid = callId;
        }
        disp.meta01 = label;
        disp.meta02 = target;
        disp.meta03 = type;
        disp.meta04 = 'client';
        dispatch({
          type: "store-disposition-code",
          payload: disp
        })
      });
  }
}

const consult = (actions: any, target: any, usepv:any, updatepvornot:boolean,log:any, type: any, label: any, contact_center_type: any, agentId: any, callId: any, dispatch: any) => {
  if(updatepvornot){
    updatePV(actions,usepv,log);
  }
  if (actions) {
    actions.consult(target)
      .then((e: any) => {
        //Disposition Framework
        let disp: Disposition = { value: "175" }
        if (contact_center_type && contact_center_type === 'five9') {
          let agentIdValue = sessionStorage.getItem("agentName");
          disp.meta00 = agentIdValue;
        } else {
          disp.meta00 = agentId;
          disp.dial_list_uid = callId;
        }
        disp.meta01 = label;
        disp.meta02 = target;
        disp.meta03 = type;
        disp.meta04 = 'client';
        dispatch({
          type: "store-disposition-code",
          payload: disp
        })
      })
      .catch((exe: any) => {
        log.error(
          "one-card-hotbutons",
          "hotbuttons-consult",{
            exe
          }
        );
        //Disposition Framework
        let disp: Disposition = { value: "990" }
        if (contact_center_type && contact_center_type === 'five9') {
          let agentIdValue = sessionStorage.getItem("agentName");
          disp.meta00 = agentIdValue;
        } else {
          disp.meta00 = agentId;
          disp.dial_list_uid = callId;
        }
        disp.meta01 = label;
        disp.meta02 = target;
        disp.meta03 = type;
        disp.meta04 = 'client';
        dispatch({
          type: "store-disposition-code",
          payload: disp
        })
      });
  }
}


/**
 * This function returns all the Hot buttons
 * @param props has all input parameters to load the Card
 * @returns JSX code for Hot Buttons
 */

export const HotButtons = (props: any) => {
  const { active, dnis, actions } = useSelector((state: any) => (
    state.hotkeys
  ));
  const choosecaller = useSelector((state: any) => (state.choosecaller));
  const dispatch = useDispatch();

  const disabled = (!((active) && (actions)));

  const { settings,log, agentId } = useCtx();
  const { hotkeys = {} } = settings;
  const {updatepv } = settings;
  const { compatible } = settings;
  const { contact_center_type } = compatible;
  const { map, dnisMap } = hotkeys;
  let updatepvornot = false;
  let pvarariable = updatepv?.usepv;
  if(pvarariable && pvarariable != "" ){
    updatepvornot = true;
  }
  const keys = ((dnisMap) && (dnisMap[dnis])) || map || [];
  let index = 0;
  const keyComps = [];
  while (index < keys.length) {
    const buttons = [];
    const maxCols = 2;
    for (let colIndex = 0; colIndex < maxCols; colIndex++) {
      if (index < keys.length) {
        let key = keys[index];
        buttons.push(
          <Col span={24 / maxCols} style={{ padding: '2px' }} >
            <Tooltip title={key.label}>
            <Button className="ant-btn--menu" style={{ fontSize: '1.0rem', whiteSpace: 'normal' }}  disabled={disabled}  size="large" block={true} onClick={
              (key.type === 'blind') ?
                (() => { transfer(actions, key.dn, pvarariable, updatepvornot,log, key.type, key.label, contact_center_type, agentId, choosecaller?.callId, dispatch) }) :
                (() => { consult(actions, key.dn, pvarariable, updatepvornot,log, key.type, key.label, contact_center_type, agentId, choosecaller?.callId, dispatch) })
            }>{key.label}</Button>
            </Tooltip>
          </Col>
        );
        index = index + 1;
      }
    }
    keyComps.push(
      <>
       <ul key="1" className="ant-drawer__menu">
          <Row>
            {buttons}
          </Row>
        </ul>
      </>
    );
  }
  return (
   <>
      <div className="ant-drawer__subtitle">Hot Buttons</div>
      {keyComps}
   </>
  );
};
